import { Injectable } from '@angular/core';
import { LocationData } from '../components/location-cascader/location.data';
import {
  LocationInfo,
  LocationModel,
} from '../components/location-cascader/location.model';
import { LoginInfo } from '../models/login/login-info.model';
import { MenuAudit } from '../models/menu/menu-audit.model';
import { ProjectSectionItem } from '../models/project/project-section-item.model';
import { OrganizationProject } from '../models/staff/organization-project.model';
import { LocalStorageService } from './local-storage.service';

import * as localForage from 'localforage';
import { EsArivhiveFileDoc } from '../models/archive/es-arivhive-file-doc.model';
import { InitWorkReportRequest } from '../models/form/init-work-report-request.model';
import { OrganizationType } from '../models/staff/organization-type.enum';
import { User } from '../models/staff/user.model';
import { FileResponse } from './request/file-response.model';
import { s12, s13, s14, s16 } from './width.const';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GlobalService {
  private static USER = 'zhgd_user';
  // private static ORG = 'zhgd_org';
  private static ORG_PROJECT = 'zhgd_org_project';
  private static TOKEN = 'zhgd_token';
  private static OUTER_TOKEN = 'zhgd_outer_token';
  private static LOGIN = 'zhgd_login';
  private static SELECT_ORG_CACHE = 'zhgd_select_org_cache';
  private static SELECT_UNIT_CACHE = 'zhgd_select_unit_cache';
  private static SELECT_UNIT_CACHE_NO_BEAM = 'zhgd_select_unit_cache_no_beam';
  private static AUDIT_VERSION = 'zhgd_audit_version';
  private static AUDIT_URL_MAP = 'zhgd_audit_url_map';
  private static AUDIT_MENU_MAP = 'zhgd_audit_menu_map';
  private static MENU_LIST = 'zhgd_menu_list';
  private static WBS_TITLE_TREE = 'zhgd_wbs_title_tree';
  private static WBS_TITLE_TREE_VERSION = 'zhgd_wbs_title_tree_version';
  private static WBS_TREE_ROOT = 'zhgd_wbs_tree_root';
  private static WBS_TREE_ROOT_VERSION = 'zhgd_wbs_tree_root_version';
  private static PASSWORD_FREE = 'zhgd_pwd_free';
  private static FORM_INIT_CACHE = 'zhgd_form_init_cache';
  private static FORM_FILL_CACHE = 'zhgd_form_fill_cache';
  private static FORM_WBS_CACHE = 'zhgd_form_wbs_cache';
  private static FORM_WBS_CACHE_V2 = 'zhgd_form_wbs_cache_v2';

  private static ANY_CACHE = 'zhgd_any_cache';

  private static ARCHIVE_EXPENDED_CACHE = 'zhgd_archive_expended_cache';

  shiftPressing = false;
  ctrlPressing = false;
  metaPressing = false;
  altPressing = false;
  halfBottom = false;

  private _searchConfig: any = {};
  private _treeCache: any = {};
  private _pager: any = {};

  s12: any = s12;
  s13: any = s13;
  s14: any = s14;
  s16: any = s16;

  _locationData: LocationModel[] = [];

  // get defaultSectionId(): number {
  //   if (!this.localStorage.getData(GlobalService.ANY_CACHE)) {
  //     return -1;
  //   }
  //   return this.localStorage.getData(GlobalService.ANY_CACHE)[
  //     'defaultSectionId'
  //   ];
  // }

  // set defaultSectionId(value: number) {
  //   const cache = this.localStorage.getData(GlobalService.ANY_CACHE) || {};
  //   cache['defaultSectionId'] = value;
  //   this.localStorage.setData(GlobalService.ANY_CACHE, cache);
  // }

  get breakSheild(): boolean {
    if (!this.localStorage.getData(GlobalService.ANY_CACHE)) {
      return false;
    }
    return this.localStorage.getData(GlobalService.ANY_CACHE)['breakSheild'];
  }

  set breakSheild(value: boolean) {
    const cache = this.localStorage.getData(GlobalService.ANY_CACHE) || {};
    cache['breakSheild'] = value;
    this.localStorage.setData(GlobalService.ANY_CACHE, cache);
  }

  get hasBeam(): boolean {
    if (!this.localStorage.getData(GlobalService.ANY_CACHE)) {
      return false;
    }
    return this.localStorage.getData(GlobalService.ANY_CACHE)['hasBeam'];
  }

  set hasBeam(value: boolean) {
    const cache = this.localStorage.getData(GlobalService.ANY_CACHE) || {};
    cache['hasBeam'] = value;
    this.localStorage.setData(GlobalService.ANY_CACHE, cache);
  }

  getPageCache(key: string): any {
    if (!this.localStorage.getData(GlobalService.ANY_CACHE)) {
      return {};
    }
    const cache = this.localStorage.getData(GlobalService.ANY_CACHE);
    return cache[key];
  }

  setPageCache(key: string, value: any) {
    const cache = this.localStorage.getData(GlobalService.ANY_CACHE) || {};
    cache[key] = value;
    this.localStorage.setData(GlobalService.ANY_CACHE, cache);
  }

  getArchiveReportCache(): FileResponse | undefined {
    const cache = this.localStorage.getData(GlobalService.ANY_CACHE) || {};
    const result = cache['archiveReport'];
    return result;
  }

  setArchiveReportCache(file: FileResponse) {
    const cache = this.localStorage.getData(GlobalService.ANY_CACHE) || {};
    cache['archiveReport'] = file;
    this.localStorage.setData(GlobalService.ANY_CACHE, cache);
  }

  // _wbsTreeRoot?: ProjectSectionItem = undefined;

  // _wbsTitleTree: NzTreeNode[] = [];

  // _formInitCache?: InitWorkReportRequest = undefined;

  get mit(): string {
    if (window.location.href.indexOf('hzsksc.com') > -1) {
      return '浙ICP备2023053663号-1';
    }
    // if (window.location.href.indexOf('hzsksc.com') > -1) { {
    //   return '浙ICP备2023053663号-2A';
    // }
    return '浙ICP备2023053663号-1';
  }

  get formInitCache() {
    const result = this.localStorage.getData(GlobalService.FORM_INIT_CACHE);
    setTimeout(() => {
      this.localStorage.clearData(GlobalService.FORM_INIT_CACHE);
    }, 1000);
    return result ? result : {};
  }

  set formInitCache(value: InitWorkReportRequest) {
    this.localStorage.setData(GlobalService.FORM_INIT_CACHE, value);
  }

  getArchiveExpendedCache(type: string) {
    const result = this.localStorage.getData(
      GlobalService.ARCHIVE_EXPENDED_CACHE + '_' + type,
    );
    return result ? result : {};
  }

  setArchiveExpendedCache(type: string, value: any) {
    this.localStorage.setData(
      GlobalService.ARCHIVE_EXPENDED_CACHE + '_' + type,
      value,
    );
  }

  saveSearchConfig(value: any) {
    const key = location.href;
    this._searchConfig[key] = value;
  }

  saveTreeCache(value: any) {
    const key = location.href;
    this._treeCache[key] = value;
  }

  savePager(value: any) {
    const key = location.href;
    this._pager[key] = value;
  }

  recoverSearchConfig() {
    const key = location.href;
    return this._searchConfig[key];
  }

  recoverTreeCache() {
    const key = location.href;
    return this._treeCache[key];
  }

  recoverPager(): {
    total: number;
    pageIndex: number;
    pageSize: number;
    pageSizeOptions: [10, 20, 30, 50, 100, 200];
  } {
    const key = location.href;
    return (
      this._pager[key] ?? {
        total: 1,
        pageIndex: 1,
        pageSize: 50,
        pageSizeOptions: [10, 20, 30, 50, 100, 200],
      }
    );
  }

  resetSearchConfig() {
    this._searchConfig = {};
    this._pager = {};
    this._treeCache = {};
  }

  setArchiveCache(doc: EsArivhiveFileDoc) {
    const cache = this.localStorage.getData(GlobalService.ANY_CACHE) || {};
    cache['archive'] = doc;
    this.localStorage.setData(GlobalService.ANY_CACHE, cache);
  }

  getArchiveCache(): EsArivhiveFileDoc {
    const cache = this.localStorage.getData(GlobalService.ANY_CACHE) || {};
    return cache['archive'];
  }

  get locationData(): LocationModel[] {
    return this._locationData;
  }

  constructor(private localStorage: LocalStorageService) {
    this.initLocation();
  }

  get isLogin(): boolean {
    return !!this.localStorage.getData(GlobalService.TOKEN);
  }

  get userInfo(): User {
    return this.localStorage.getData(GlobalService.USER);
  }

  // get orgInfo(): Organization {
  //   return this.localStorage.getData(GlobalService.ORG);
  // }

  get orgProjectInfo(): OrganizationProject {
    return this.localStorage.getData(GlobalService.ORG_PROJECT);
  }

  get projectId(): number {
    return environment.projectId;
  }

  get token(): string {
    return this.localStorage.getData(GlobalService.TOKEN);
  }

  get outerToken(): string {
    return this.localStorage.getData(GlobalService.OUTER_TOKEN);
  }

  get auditVersion(): string {
    return this.localStorage.getData(GlobalService.AUDIT_VERSION);
  }

  get loginInfo(): LoginInfo {
    return this.localStorage.getData(GlobalService.LOGIN);
  }

  get selectOrgCache(): any[] {
    return this.localStorage.getData(GlobalService.SELECT_ORG_CACHE);
  }

  get selectUnitCache(): any[] {
    return this.localStorage.getData(GlobalService.SELECT_UNIT_CACHE);
  }

  get selectUnitCacheNoBeam(): any[] {
    return this.localStorage.getData(GlobalService.SELECT_UNIT_CACHE_NO_BEAM);
  }

  async getWbsTreeRoot(): Promise<ProjectSectionItem | null> {
    // return this.localStorage.getData(GlobalService.WBS_TREE_ROOT);
    return await localForage.getItem(GlobalService.WBS_TREE_ROOT);
  }

  get wbsTreeRootVersion(): string {
    return this.localStorage.getData(GlobalService.WBS_TREE_ROOT_VERSION);
  }

  async getWbsTitleTree(): Promise<ProjectSectionItem | null> {
    return await localForage.getItem(GlobalService.WBS_TITLE_TREE);
  }

  get wbsTitleTreeVersion(): string {
    return this.localStorage.getData(GlobalService.WBS_TITLE_TREE_VERSION);
  }

  get menuIdAuditsMap(): { [key: string]: MenuAudit } {
    return this.localStorage.getData(GlobalService.AUDIT_MENU_MAP);
  }

  get urlAuditMap(): { [key: string]: MenuAudit } {
    return this.localStorage.getData(GlobalService.AUDIT_URL_MAP);
  }

  getFormCodeWbsHistory(formCode: string) {
    return this.localStorage.getData(
      GlobalService.FORM_WBS_CACHE +
        '_' +
        this.userInfo.userId +
        '_' +
        formCode,
    );
  }

  // setFormCodeWbsHistory(formCode: string, history: any[][]) {
  //   this.localStorage.setData(
  //     GlobalService.FORM_WBS_CACHE +
  //       '_' +
  //       this.userInfo.userId +
  //       '_' +
  //       formCode,
  //     history
  //   );
  // }

  clearFormCodeWbsHistory(formCode: string) {
    return this.localStorage.clearData(
      GlobalService.FORM_WBS_CACHE +
        '_' +
        this.userInfo.userId +
        '_' +
        formCode,
    );
  }

  getFormCodeWbsHistoryV2(formCode: string) {
    return this.localStorage.getData(
      GlobalService.FORM_WBS_CACHE_V2 +
        '_' +
        this.userInfo.userId +
        '_' +
        formCode,
    );
  }

  setFormCodeWbsHistoryV2(formCode: string, history: FormCodeWbsHistory[]) {
    this.localStorage.setData(
      GlobalService.FORM_WBS_CACHE_V2 +
        '_' +
        this.userInfo.userId +
        '_' +
        formCode,
      history,
    );
  }

  getFormCodeFillHistory(formCode: string) {
    return this.localStorage.getData(GlobalService.FORM_FILL_CACHE + formCode);
  }

  setFormCodeFillHistory(formCode: string, history: any) {
    this.localStorage.setData(
      GlobalService.FORM_FILL_CACHE + formCode,
      history,
    );
  }

  get menuList(): {
    title: string;
    icon?: string;
    open: boolean;
    children: { title: string; url: string }[];
  }[] {
    return this.localStorage.getData(GlobalService.MENU_LIST);
  }

  set passwordFree(free: boolean) {
    this.localStorage.setData(GlobalService.PASSWORD_FREE, free);
  }

  get passwordFree(): boolean {
    return this.localStorage.getData(GlobalService.PASSWORD_FREE);
  }

  set token(token: string) {
    this.localStorage.setData(GlobalService.TOKEN, token);
  }

  set outerToken(token: string) {
    this.localStorage.setData(GlobalService.OUTER_TOKEN, token);
  }

  set auditVersion(version: string) {
    this.localStorage.setData(GlobalService.AUDIT_VERSION, version);
  }

  // set orgInfo(org: Organization) {
  //   this.localStorage.setData(GlobalService.ORG, org);
  // }

  set orgProjectInfo(info: OrganizationProject) {
    this.localStorage.setData(GlobalService.ORG_PROJECT, info);
  }

  set loginInfo(info: LoginInfo) {
    this.localStorage.setData(GlobalService.LOGIN, info);
  }

  set userInfo(user: User) {
    this.localStorage.setData(GlobalService.USER, user);
  }

  set selectOrgCache(cache: any[]) {
    this.localStorage.setData(GlobalService.SELECT_ORG_CACHE, cache);
  }

  set selectUnitCache(cache: any[]) {
    this.localStorage.setData(GlobalService.SELECT_UNIT_CACHE, cache);
  }

  set selectUnitCacheNoBeam(cache: any[]) {
    this.localStorage.setData(GlobalService.SELECT_UNIT_CACHE_NO_BEAM, cache);
  }

  async setWbsTreeRoot(wbsTreeRoot: ProjectSectionItem) {
    await localForage.setItem(GlobalService.WBS_TREE_ROOT, wbsTreeRoot);
  }

  set wbsTreeRootVersion(version: string) {
    this.localStorage.setData(GlobalService.WBS_TREE_ROOT_VERSION, version);
  }

  async setWbsTitleTree(wbsTitleTree: ProjectSectionItem) {
    await localForage.setItem(GlobalService.WBS_TITLE_TREE, wbsTitleTree);
  }

  set wbsTitleTreeVersion(version: string) {
    this.localStorage.setData(GlobalService.WBS_TITLE_TREE_VERSION, version);
  }

  set menuIdAuditsMap(audits: { [key: string]: MenuAudit }) {
    this.localStorage.setData(GlobalService.AUDIT_MENU_MAP, audits);
  }

  set urlAuditMap(audits: { [key: string]: MenuAudit }) {
    this.localStorage.setData(GlobalService.AUDIT_URL_MAP, audits);
  }

  set menuList(
    menuList: {
      title: string;
      icon?: string;
      open: boolean;
      children: { title: string; url: string }[];
    }[],
  ) {
    this.localStorage.setData(GlobalService.MENU_LIST, menuList);
  }

  logout(): void {
    const free = this.passwordFree;
    setTimeout(async () => {
      await localForage.clear();
      this.clearLoginInfo();
      // this.localStorage.clearAll();
      this.localStorage.setData(GlobalService.ANY_CACHE, {});
      if (location.href.indexOf('sanqiao.hzsksc.com') === -1) {
        location.href = '/#/signin';
      } else {
        location.href = 'https://sanqiao.hzsksc.com:8046';
      }
    }, 100);
  }

  clearLoginInfo(): void {
    this.localStorage.clearData(GlobalService.USER);
    // this.localStorage.clearData(GlobalService.ORG);
    this.localStorage.clearData(GlobalService.ORG_PROJECT);
    this.localStorage.clearData(GlobalService.TOKEN);
    this.localStorage.clearData(GlobalService.LOGIN);
    this.localStorage.clearData(GlobalService.SELECT_ORG_CACHE);
    this.localStorage.clearData(GlobalService.SELECT_UNIT_CACHE);
    this.localStorage.clearData(GlobalService.SELECT_UNIT_CACHE_NO_BEAM);
    this.localStorage.clearData(GlobalService.AUDIT_VERSION);
    this.localStorage.clearData(GlobalService.AUDIT_URL_MAP);
    this.localStorage.clearData(GlobalService.AUDIT_MENU_MAP);
    this.localStorage.clearData(GlobalService.MENU_LIST);
    this.localStorage.clearData(GlobalService.WBS_TITLE_TREE);
    this.localStorage.clearData(GlobalService.WBS_TITLE_TREE_VERSION);
    this.localStorage.clearData(GlobalService.WBS_TREE_ROOT);
    this.localStorage.clearData(GlobalService.WBS_TREE_ROOT_VERSION);
    this.localStorage.clearData(GlobalService.PASSWORD_FREE);
    this.localStorage.clearData(GlobalService.FORM_INIT_CACHE);
    // this.localStorage.clearData(GlobalService.FORM_WBS_CACHE);
  }

  login(loginInfo: LoginInfo) {
    this.localStorage.setData(GlobalService.LOGIN, loginInfo);
    this.localStorage.setData(GlobalService.TOKEN, loginInfo.token);
    if (window.location.href.indexOf('#/open') === -1) {
      location.href = '/#/home/notice';
    } else {
      console.log('开放平台登录');
      location.reload();
    }
  }

  openLogin(loginInfo: LoginInfo) {
    this.localStorage.setData(GlobalService.LOGIN, loginInfo);
    this.localStorage.setData(GlobalService.TOKEN, loginInfo.token);
  }

  set debugIp(ip: string) {
    this.localStorage.setData('debug_ip', ip);
  }

  get debugIp(): string {
    return this.localStorage.getData('debug_ip');
  }

  get debugUrl(): string {
    return this.localStorage.getData('debug_ip')
      ? `http://${this.localStorage.getData('debug_ip')}`
      : '';
  }

  get debugWs(): string {
    return this.localStorage.getData('debug_ip')
      ? `ws://${this.localStorage.getData('debug_ip')}/push`
      : '';
  }

  private initLocation() {
    const mapL1 = new Map<string, LocationModel>();
    const mapL2 = new Map<string, LocationModel>();
    const listL3 = new Array<LocationInfo>();
    for (const location of LocationData) {
      if (location.level === 1) {
        mapL1.set(location.id, {
          label: location.name,
          value: location.id,
          level: location.level,
          isLeaf: false,
          children: [],
        });
      }
      if (location.level === 2) {
        mapL2.set(location.id, {
          label: location.name,
          value: location.id,
          isLeaf: false,
          level: location.level,
          parentId: location.parentId,
          children: [],
        });
      }
      if (location.level === 3) {
        listL3.push(location);
      }
    }
    for (const location of listL3) {
      const l2 = mapL2.get(location.parentId!);
      if (l2) {
        l2.children!.push({
          label: location.name,
          value: location.id,
          level: location.level,
          parentId: location.parentId,
          isLeaf: true,
        });
      }
    }
    const l2 = Array.from(mapL2.values());
    for (const location of l2) {
      const l1 = mapL1.get(location.parentId!);
      if (l1) {
        l1.children!.push(location);
      }
    }

    this._locationData = Array.from(mapL1.values());
  }

  writeAbleByUrl(url: string): boolean {
    for (const post of this.userInfo.userPosts ?? []) {
      if (post.organizationType === OrganizationType.OPERATE) {
        return true;
      }
    }
    return !!this.urlAuditMap[url]?.writAble;
  }
}

export class FormCodeWbsHistory {
  unitCascaderValue?: any[];
  segmentCode?: string;
  layerCode?: string;
}
